import { ModalContent } from '@nile/banyan/src/Utils/style';
import styled from 'styled-components';

const Modal = styled(ModalContent)`
  background: none;
  width: 100%;
  .FormContainer {
    padding: 0 !important;
  }
  .save-card {
    // margin: 0 !important;
    background: none;
  }
  .Polaris-Card {
    border-radius: 8px !important;
  }
  .reportSection {
    height: 100%;
  }
`;

export { Modal };
